<template>
  <div>
    <div class="background-color-white">
      <v-btn
        v-if="$route.name !== 'identification'"
        class="back-button-position"
        color="primary"
        icon
        @click="$router.back()"
        large
      >
        <v-icon color="primary">mdi-chevron-left</v-icon>
      </v-btn>
    </div>
    <router-view
      :identification="identification"
      :code="code"
      :fetchCart="fetchCart"
      :registration="registration"
      :signUp="signUp"
      :updateCode="updateCode"
      :updateIdentification="updateIdentification"
      :updatePhone="updatePhone"
      :updateRegistration="updateRegistration"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { formatPhoneNumber } from "@/util.js";

export default {
  name: "SignUpView",
  computed: {
    ...mapGetters({
      authorized: "auth/isAuthenticated",
      userClickedCartButtonBeforeAuthenticated:
        "cart/userClickedCartButtonBeforeAuthenticated",
    }),
    ...mapState({
      account: (state) => state.auth.account,
    }),
  },
  mounted() {
    this.$store.commit("auth/SHOW_SMS_RETRY_MESSAGE", false);
  },
  data() {
    return {
      code: { input0: null, input1: null, input2: null, input3: null },
      identification: { firstName: null, lastName: null, phone: null },
      registration: { confirmPassword: null, email: null, password: null },
    };
  },
  methods: {
    async fetchCart() {
      await this.$store.dispatch("cart/fetch");
      this.routeAfterSignUp();
    },
    routeAfterSignUp() {
      this.userClickedCartButtonBeforeAuthenticated
        ? this.$router.push({ name: "cart" })
        : this.$router.push({ name: "home" });
    },
    async signUp() {
      const { input0, input1, input2, input3 } = this.code;
      const verificationCode =
        input1 !== null ? input0.concat(input1, input2, input3) : null;

      const info = {
        email: this.registration.email,
        password: this.registration.password,
      };

      /*
       * if NCM_ACCOUNT (account) then PUT /user,
       * otherwise (no account) POST /register
       */

      this.account
        ? this.$store.dispatch("auth/updateAndAuthenticateUser", info)
        : await this.$store.dispatch("auth/register", {
            ...info,
            country_code: 1,
            name: `${this.identification.firstName} ${this.identification.lastName}`,
            phone: this.identification.phone,
            verification_code: verificationCode,
          });
      this.authorized && this.fetchCart();
    },
    updateCode(input, val) {
      this.code[`input${input}`] = val;
    },
    updateIdentification(name, val) {
      this.identification[name] = val;
    },
    updatePhone(val) {
      this.identification.phone = formatPhoneNumber(val);
    },
    updateRegistration(name, val) {
      this.registration[name] = val;
    },
  },
};
</script>

<style scoped>
.back-button-position {
  position: absolute;
  left: 16px;
  top: 18px;
}
</style>
